module.exports = "../study/imgs/maps/Kanagawa/S8/Helth/Mosquito/Kanagawa_Mosquito_HadGEM2_RCP45_Now.png";